// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__percentBarContainer {
  display: flex;
  min-width: 33%;
  height: 25px;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__percentBar {
  display: flex;
  flex: 1;
  height: 100%;
  border: 1px solid rgb(153, 153, 153);
  position: relative;
  align-items: center;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__percentText {
  font-size: 15px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__data {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__data .app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__element {
    height: 100%;
  }

.app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__data .app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__element:first-child {
      margin-bottom: 20px;
    }

.app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__data .app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__element .app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__assump {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

.app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__data .app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__element .app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__estim {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

.app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__data .app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__element .app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__activities {
      display: flex;
      white-space: pre-wrap;
    }
`, "",{"version":3,"sources":["webpack://./app/pages/Project/ProductionManagement/Dashboards/Widgets/CostCard/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AA0BxB;;AAxBE;IACE,YAAY;EAsBd;;AApBE;MACE,mBAAmB;IACrB;;AAEA;MACE,aAAa;MACb,mBAAmB;MACnB,mBAAmB;IACrB;;AAEA;MACE,aAAa;MACb,mBAAmB;MACnB,mBAAmB;IACrB;;AAEA;MACE,aAAa;MACb,qBAAqB;IACvB","sourcesContent":[".percentBarContainer {\n  display: flex;\n  min-width: 33%;\n  height: 25px;\n}\n\n.percentBar {\n  display: flex;\n  flex: 1;\n  height: 100%;\n  border: 1px solid rgb(153, 153, 153);\n  position: relative;\n  align-items: center;\n}\n\n.percentText {\n  font-size: 15px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0);\n}\n\n.data {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  & .element {\n    height: 100%;\n\n    &:first-child {\n      margin-bottom: 20px;\n    }\n\n    & .assump {\n      display: flex;\n      align-items: center;\n      margin-bottom: 10px;\n    }\n\n    & .estim {\n      display: flex;\n      align-items: center;\n      margin-bottom: 10px;\n    }\n\n    & .activities {\n      display: flex;\n      white-space: pre-wrap;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"percentBarContainer": `app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__percentBarContainer`,
	"percentBar": `app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__percentBar`,
	"percentText": `app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__percentText`,
	"data": `app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__data`,
	"element": `app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__element`,
	"assump": `app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__assump`,
	"estim": `app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__estim`,
	"activities": `app-pages-Project-ProductionManagement-Dashboards-Widgets-CostCard-___styles__activities`
};
export default ___CSS_LOADER_EXPORT___;
